import { render, staticRenderFns } from "./share-tab.vue?vue&type=template&id=47a68ad9&scoped=true&"
import script from "./share-tab.vue?vue&type=script&lang=js&"
export * from "./share-tab.vue?vue&type=script&lang=js&"
import style0 from "./share-tab.vue?vue&type=style&index=0&id=47a68ad9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a68ad9",
  null
  
)

export default component.exports